import { render, staticRenderFns } from "./ApplicationEdit.vue?vue&type=template&id=35396cf8&scoped=true&"
import script from "./ApplicationEdit.vue?vue&type=script&lang=ts&"
export * from "./ApplicationEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35396cf8",
  null
  
)

export default component.exports